import { useUserAccessType } from "hooks/Subscriptions/useUserAccessType";
import { UserAccessTypeToAlgoliaFilterMap } from "./constants";

export function useAccessTypeFilterForUser() {
  const userAccessType = useUserAccessType();
  return UserAccessTypeToAlgoliaFilterMap.get(userAccessType) || [];
}
